import React, { PureComponent } from 'react'
import DefaultLayout from '../../DefaultLayout'
import PropTypes from 'prop-types'
import { withRouter } from '../../../Shared/Routing/withRouter'
import Loader from '../../../Shared/Loader'
import { getHashInfoByHashAndType } from '../../../../api'
import history from '../../../../history'
import Alert from '../../../Shared/Alert'
import Box from '../../../Shared/Box'

const HASH_TYPES = {
  HOTELIER_LOGIN_HASH: 1,
}

class LegacyHotelierPropertyJumpPage extends PureComponent {

  state = {
    loading: true,
    error: null
  }

  componentDidMount () {
    this.init()
  }

  init () {
    const hash = this.props.router.params.hash
    getHashInfoByHashAndType(hash, HASH_TYPES.HOTELIER_LOGIN_HASH).fetchPromise.then((response) => {
      this.setState({ loading: false })
      history.push('/property/' + response.giataId)
    }).catch(() => {
      this.setState({ error: 'Error: Failed to find info to hash', loading: false })
    })
  }

  render () {
    return (
      <DefaultLayout>
        <div className={'page'}>
          <Box>
            {this.state.loading && <Loader/>}
            {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

LegacyHotelierPropertyJumpPage.propTypes = {
  router: PropTypes.object
}

export default withRouter((LegacyHotelierPropertyJumpPage))
